import React from 'react';

import {MainHeader} from 'presentation/components/MainHeader';
import {PageWrapperLayout} from 'presentation/components/PageWrapperLayout';
import {translations} from 'presentation/translations-new';
import {HeaderTabNavigation} from 'presentation/components';
import {AuthorizationsEnum} from 'presentation/constants';
import {useMediaQueries} from 'presentation/pages/private/hooks';
import {AutoSolEnum} from 'main/analytics/gaTagsEnum';
import {Tab} from 'presentation/components/HeaderTabNavigation/types';
import {SelectedPlanBar} from '../../components';
import {useAuthorizations} from '../../hooks';

const {title} = translations['pt-br'].privateFlow.requestAuthorizations;
const {authorizations, requests} = translations['pt-br'].privateFlow.requestAuthorizations.tabs;

export function Authorizations() {
	const {isMobile} = useMediaQueries();
	const {handleBack, handleChangeBeneficiary} = useAuthorizations();

	const tabs: Tab[] = [
		{
			route: AuthorizationsEnum.AUTHORIZATIONS_REQUESTS,
			name: requests,
			dataTagId: AutoSolEnum.AS_CLICK_ABA_EM_ANDAMENTO,
		},
		{
			route: AuthorizationsEnum.AUTHORIZATIONS,
			name: authorizations,
			dataTagId: AutoSolEnum.AS_CLICK_ABA_HISTORICO,
		},
	];

	return (
		<PageWrapperLayout title={title}>
			<MainHeader
				dataTagId={{
					backButton: AutoSolEnum.CLICK_VOLTAR_HOME_AUTOSOL,
					closeButton: AutoSolEnum.CLICK_FECHAR_AUTOSOL,
				}}
				title={title}
				handleBack={handleBack}
				handleClose={handleBack}
				variant="subRoute"
			/>
			<SelectedPlanBar handleChangeBeneficiary={handleChangeBeneficiary} />
			<HeaderTabNavigation variant={isMobile ? 'fullWidth' : 'scrollable'} tabs={tabs} />
		</PageWrapperLayout>
	);
}
